import { toBase64 } from '../encode.utils';
import { getEnvValueToEvents } from '../env.utils';
import { pushObjectDataLayer } from './gtm.events';

interface ITriggerLoginSuccess {
  document: string;
  priceList: string;
  docType: string;
  externalDistributorName: string;
}

export const triggerLoginSuccessEvent = ({
  document,
  priceList,
  externalDistributorName,
  docType,
}: ITriggerLoginSuccess) => {
  const data = {
    event: 'virtualEventA2',
    tipoevento: 'login exitoso',
    usuarioid: toBase64(document),
    giro: priceList,
    tipousuario: externalDistributorName,
    tipodocumento: docType,
  };
  pushObjectDataLayer(data, triggerLoginSuccessEvent.name);
};

interface ITtriggerInitializeUser {
  documentNumber: string;
  priceList: string;
  externalDistributorName: string;
  documentType: string;
  department: string;
  district: string;
  appInstanceId: string;
  channelName: string;
  priceGroupId: string;
  priceGroupName: string;
  distributorId: string;
  branchName: string;
}

export const triggerInitializeUserEvent = (customer: ITtriggerInitializeUser) => {
  const userId = toBase64(customer.documentNumber);

  const data = {
    event: 'login_Status',
    loginStatus: 'Sesión iniciada',
    tipoevento: 'login exitoso',
    usuarioid: userId,
    giro: customer.priceList,
    tipousuario: customer.externalDistributorName,
    tipodocumento: customer.documentType,
    departamento: customer.department,
    distrito: customer.district,
    app_instance_id: customer.appInstanceId,
    canal: customer.channelName,
    ambiente: getEnvValueToEvents(),
    plataforma: 'web',
    grupo_precio: `${customer.priceGroupId}-${customer.priceGroupName}`,
    cod_dex: customer.distributorId,
    sede: customer.branchName,
  };
  pushObjectDataLayer(data, triggerInitializeUserEvent.name);
};
